import React from "react";

export default function AboutApp() {
  return (
    <>
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
        <h2>The Strengths of The Sustainable Institute</h2>
              <p className="mb-4 lh-190">
              The Sustainable Institute offers a wide range of consulting &amp; advisory services and
utilizes its strong research and strategy base to support each client's decision-making.
The firm’s strategic marketing approach keeps innovation at the heart of the process,
using insight into both advanced technological developments and novel business
models.
              </p>
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-5">
              
              
              <ul className="list-unstyled">
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">An international and interdisciplinary team fortified with highly technical
backgrounds and complemented by financial, communication, political, regulatory
and innovation experts</p>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">
                      Technologically advanced solutions which lead to high-quality results
                      </p>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">
                      A state-of-the-art tool suite that contributes and ensures a project’s optimization
                      </p>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">
                      A multilingual firm, which facilitates optimal communication, coordination, and
strategy in large projects and programs
                      </p>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">
                      Transparency in our daily activities and subscribe to the EU Transparency Register
                      </p>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">
                      
An extensive network of partners and experts worldwide
                      </p>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">

                      A single point of accountability and leadership in every project                      </p>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="badge badge-circle badge-primary mr-3">
                        <span className="ti-check"></span>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0">
                      
A team culture of initiative and responsibility that gets the job done right, on time, and on budget
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              <div className="about-content-right">
                <img
                  src="assets/img/service3.jpg"
                  width="500"
                  alt="about us"
                  style={{borderRadius:'20px'}}
                  className="img-fluid"
                />
              </div>
              
            </div>
            
          </div>
        </div>
      </section>
    </>
  );
}
